import { constipation } from './initial/flow';

export const ConstipationFlows = { constipation };
